import { t } from 'i18next'

import { formatDateToString, formatMoney } from '~/helpers'
import type { WalletBalanceOriginRow } from '~/modules/retailMedia/components/WalletBalanceOrigin/types'
import {
  labelSubtypes,
  labelTypes
} from '~/modules/retailMedia/store/common/constants'

import { buildOriginSchemaColumn } from '../WalletTableTransaction/getTransactionOriginLabel'
import {
  ColumnMainAndDetail,
  ValueTransaction
} from '../WalletTableTransaction/styles'

type SchemaArgs = {
  originById: Map<string, WalletBalanceOriginRow>
  showOriginColumn?: boolean
}

export const schema = ({
  originById,
  showOriginColumn = true
}: SchemaArgs): TableSchema<CheckingAccountTransaction> => ({
  date: {
    title: t('rm:wallet.movimentations.table.column.title.date'),
    render: rowData => formatDateToString(rowData?.created_at)
  },
  ...(showOriginColumn ? buildOriginSchemaColumn(originById) : {}),
  value: {
    title: t('rm:wallet.movimentations.table.column.title.value'),
    render: rowData => (
      <ValueTransaction transactionType={rowData?.transaction_type}>
        <span className="amount">
          {formatMoney(rowData?.amount, false, 'R$ 0,00')}
        </span>
      </ValueTransaction>
    )
  },
  type: {
    title: t('rm:wallet.movimentations.table.column.title.type'),
    render: rowData => (
      <ColumnMainAndDetail>
        <span className="mainInfo">
          {labelTypes?.[rowData?.transaction_type] || rowData?.transaction_type}
        </span>{' '}
        <small className="detail">
          {
            labelSubtypes?.[rowData?.transaction_type]?.[
              rowData?.transaction_subtype
            ]
          }
        </small>
      </ColumnMainAndDetail>
    )
  }
})
